import { Component, OnInit } from '@angular/core';
import { AuthService, Role } from 'ac-ui-core-local';

@Component({
	selector: 'azc-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
	public isSuperAdmin: boolean;
	public isAdmin: boolean;

	constructor(private _as: AuthService) { }

	ngOnInit() {
		this._as.watchUser().subscribe(user => {
			this.isAdmin = user && user.roles.some(role => role === Role.Administrator);
			this.isSuperAdmin = user && user.roles.some(role => role === Role.SuperAdministrator);
		});
	}
}
